/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Sug_StackInputs */

const en_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tech stack?`)
};

const ar_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزمة التقنيات؟`)
};

const bn_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টেক স্ট্যাক?`)
};

const de_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tech-Stack?`)
};

const es_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Pila de tecnología?`)
};

const fr_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pile technologique ?`)
};

const pt_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilha de tecnologia?`)
};

const zh_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术堆栈？`)
};

const tr_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknoloji yığını mı?`)
};

const ru_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технический стек?`)
};

const pl_chat_sug_stack = /** @type {(inputs: Chat_Sug_StackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stos technologii?`)
};

/**
* | output |
* | --- |
* | "Tech stack?" |
*
* @param {Chat_Sug_StackInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_sug_stack = /** @type {((inputs?: Chat_Sug_StackInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Sug_StackInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_sug_stack(inputs)
	if (locale === "bn") return bn_chat_sug_stack(inputs)
	if (locale === "de") return de_chat_sug_stack(inputs)
	if (locale === "es") return es_chat_sug_stack(inputs)
	if (locale === "fr") return fr_chat_sug_stack(inputs)
	if (locale === "pt") return pt_chat_sug_stack(inputs)
	if (locale === "zh") return zh_chat_sug_stack(inputs)
	if (locale === "tr") return tr_chat_sug_stack(inputs)
	if (locale === "ru") return ru_chat_sug_stack(inputs)
	if (locale === "pl") return pl_chat_sug_stack(inputs)
	return en_chat_sug_stack(inputs)
});